import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { referralWithdrawDialogOpenAtom } from '@root/features/referral/atoms'

import { ReferralWithdrawDialog } from './referral-withdraw-dialog'

export const ReferralWithdrawDialogController = () => {
  const [open, setOpen] = useAtom(referralWithdrawDialogOpenAtom)

  return (
    <AnimatePresence>
      {open ? (
        <ReferralWithdrawDialog open={true} onOpenChange={setOpen} />
      ) : undefined}
    </AnimatePresence>
  )
}
